import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getData } from '../../redux/Counter';
import ServiceRequest from '../../service/ServiceRequest';
import MainService from '../../service/MainService';
import { Language } from '@react-lang/language';
import { Outlet } from "react-router-dom";
import NavBar from '../component/NavBar';
import Layout1 from '../component/Layout1';
import ScrollTop from '../component/ScrollTop';
import WhatsApp from '../component/WhatsApp';
function LandingPage() {
    const [loading, setLoading] = useState((
        <div className='card__image loading'>
            <div className="spinner-border">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    ));
    const dispacth = useDispatch();
    const requestCallback = (response) => {
        if(response) {
            let background = response.background;
            let about = response.about;
            let data = {
                background: background,
                ourBusinessList: response.ourBusinessList,
                about: about,
                client: response.client,
                portfolio: response.galery,
                address: response.address,
                career: response.career,
                layout: {
                    background: background.thumbnail,
                    typewrite: about.typewrite,
                    title: about.title
                }
            }
            dispacth(getData(data))
            setLoading('');
        }
    }
    const requestService = (lang) => {
        ServiceRequest(MainService(lang), requestCallback);
    }

    return (
        <Language.Consumer>
            {({lang}) => 
                <>
                    {requestService(lang)}
                    {loading}
                    <NavBar />
                    <Layout1 />
                    <main id="main" className="main">
                        <Outlet />
                        <ScrollTop />
                        <WhatsApp />
                    </main>
                </>
            }
        </Language.Consumer>
    );
}
export default LandingPage;